import { useEffect, useRef } from "react";
import "./notebookMain.css";
import starIcon from "../icons/star.png";
import userIcon from "../icons/user-black.png";
import locationIcon from "../icons/location.png";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { setFontSize } from "../utils/fonts";
import { compareAsc, format } from "date-fns";
import SearchInput from "../SearchInput/SearchInput";

const NotebookMain = ({
  notebookItems,
  searchOpened,
  addingChecked,
  windowResized,
}) => {
  const itemHeightRatio = 6,
    fontHeightHeaderRatio = 4.2;

  const mainRef = useRef();
  const prevDateRef = useRef();

  const resizer = () => {
    const main = document.querySelector(".notebook-main");
    if (main) {
      const mainDim = main.getBoundingClientRect();
      const items = main.querySelectorAll(".notebook-item");
      items.forEach((item) => {
        item.style.height = `${mainDim.height / itemHeightRatio}px`;
        setFontSize(item, fontHeightHeaderRatio);
      });
    }
  };

  const checkIfSameDate = (date, prevDate) => {
    const first = new Date(date),
      second = new Date(prevDate);
    return (
      compareAsc(
        new Date(first.setHours(0, 0, 0, 0)),
        new Date(second.setHours(0, 0, 0, 0))
      ) !== 0
    );
  };

  window.addEventListener("resize", resizer);

  useEffect(() => {
    resizer();
    return () => {
      window.removeEventListener("resize", resizer);
    };
  }, [windowResized, notebookItems]);

  return (
    <div className="notebook-main" ref={mainRef}>
      {(searchOpened || addingChecked) && <SearchInput />}
      <div className="notebook-items">
        {notebookItems.map((item, index) => {
          const { id, text, date, users, locations, isBookmarked } = item;
          if (prevDateRef.current === undefined) prevDateRef.current = date; // prvi prolaz
          const isDifferentDate = checkIfSameDate(date, prevDateRef.current);
          if (isDifferentDate) prevDateRef.current = date;
          return (
            <div key={id}>
              {isDifferentDate && index !== 0 && (
                <hr className="notebook-item-line" />
              )}
              <article
                className={`${
                  isBookmarked ? "notebook-item bookmarked" : "notebook-item"
                }`}
              >
                <div className="notebook-item-header">
                  <div className="notebook-item-header-info">
                    <div className="notebook-item-checkbox" />
                    <span className="notebook-item-date">
                      {format(date, "dd.MM.yyyy")}
                    </span>
                    <div className="notebook-item-icon">
                      <AccessTimeIcon />
                    </div>
                    <span className="notebook-item-date">
                      {format(date, "HH:mm")}
                    </span>
                  </div>
                  <div className="notebook-item-icons">
                    <div className="notebook-item-icon">
                      {isBookmarked && <img src={starIcon} alt="" />}
                    </div>
                    <div className="notebook-item-icon">
                      {locations.length !== 0 && (
                        <img src={locationIcon} alt="" />
                      )}
                    </div>
                    <div className="notebook-item-icon">
                      {users.length !== 0 && <img src={userIcon} alt="" />}
                    </div>
                  </div>
                </div>
                <span className="notebook-item-text">{text}</span>
              </article>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default NotebookMain;
